'use client'

import { ReactElement, ReactNode } from 'react'

import { Button } from '@/components/UiElements'
import HelpTooltip from '@/components/UiElements/HelpTooltip'

type SettingsDialogTriggerProps = {
  icon: ReactElement
  label: string
  help?: ReactNode
  onClick: () => void
}

const SettingsDialogTrigger = ({ icon, label, help, onClick }: SettingsDialogTriggerProps) => {
  const button = (
    <Button
      size="md"
      type="alt"
      icon={icon}
      iconClassName="flex h-[18px] w-[18px] items-center justify-center"
      className="!h-[56px] w-full !justify-start !border-gray-300 !bg-white !px-md !py-sm !text-text-md !text-gray-900 !shadow-md hover:!border-primary-500 hover:!bg-white focus:!border-primary-500 focus:!bg-white"
      onClick={onClick}
    >
      {label}
    </Button>
  )

  return help ? (
    <HelpTooltip help={help} title={label}>
      <div className="w-full">{button}</div>
    </HelpTooltip>
  ) : button
}

export default SettingsDialogTrigger
